import { useEffect } from 'react';
import { UserManager } from 'oidc-client-ts';
import { getOidcConfig } from '../oidc-config-dynamic';

// This component handles silent token renewal
// It calls the oidc-client-ts silent renew callback and renders nothing
// The actual renewal is handled by react-oidc-context
export default function SilentRenew() {
    useEffect(() => {
        // Get the OIDC configuration and create a UserManager instance
        const initializeSilentRenew = async () => {
            try {
                const config = await getOidcConfig();
                const userManager = new UserManager(config);
                await userManager.signinSilentCallback();
            } catch (error) {
                // Ignore errors - the library will handle them appropriately
                console.warn('Silent renew callback error:', error);
            }
        };

        initializeSilentRenew();
    }, []); // Empty dependency array to run only once

    return null;
}
